import { useRepositoryQuery } from '@mews-commander/data-access';

export const useQueueItemsDetailsData = (id: string) =>
    useRepositoryQuery(
        'enterpriseBuilder',
        'getQueueItemsDetails',
        { enterpriseBuilderQueueItemIds: [id] },
        { select: (data) => data?.enterpriseBuilderQueueItemsDetails?.[0], refetchOnMount: 'always' }
    );
